import { withInstall } from '@tav-ui/utils/with-install'
import FileLog from './index.vue'

export * from './types'
export const TaFileLog = withInstall(FileLog)
export default TaFileLog
